<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <span class="font-weight-bold white--text">{{cutOffPeriod}}</span>
                </v-toolbar>
            </v-card>
            <v-alert v-if="approved_timereport" :value="true" color="warning" icon="warning" outline style="margin:10px 0px 10px 0px;">
                This Timesheet has been approved already. 
            </v-alert> 
            <v-alert v-if="!loading && cutoff_details.status==commonfn.getStatusCode('Frozen')" :value="true" color="warning" icon="warning" outline style="margin-top:10px;">
                This period is already <b>Frozen</b>. You will not be able to change this record.
            </v-alert>  
            <v-alert v-if="!loading && cutoff_details.status==commonfn.getStatusCode('Closed')" :value="true" color="warning" icon="warning" outline style="margin-top:10px;">
                This period is already <b>Closed</b>. You will not be able to change this record.
            </v-alert>
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold">Overtime Requests</span>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="overtime-page" color="black"></help-link>
                    <v-btn icon title="Add Overtime" @click="showOvertime" :disabled="disableConditions">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="overtime_details"
                    :loading="loading"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" style="cursor:pointer;" title="Click to view timesheet for this period">
                            <td>{{ props.item.transDate | moment("YYYY-MM-DD") }}</td>
                            <td>{{ props.item.taskName }}-{{ props.item.taskDescription }}</td>
                            <td>{{ props.item.hoursStr }}</td>
                            <td>{{ props.item.chargeableHours }}</td>
                            <td>{{ props.item.startTime | moment("hh:mm a") }} - {{ props.item.endTime | moment("hh:mm a") }}</td>
                            <td>
                                <span v-if="props.item.offsetOrPay==1">Offset</span>
                                <span v-else>Payroll</span>
                            </td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogOvertime" width="500" persistent>   
            <overtime ref="overtimeRef" @send="getOvertime(false)" :dialogOvertime.sync="dialogOvertime"></overtime>
        </v-dialog>
    </v-layout>  
</template>

<script>

import overtimeApi from '@/api/overtime'
import commonfn from '@/common/functions'

export default {     
    name: 'MyOvertime',
    metaInfo: {
        title: 'My Overtime',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Overtime' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'overtime': () => import('@/components/Attendance/Overtime2'),
    },   
    data () {
      return {
        error: false,
        errorMessage: '',
        loading: false,
        loading_download: false,
        serverDate: null,
        headers: [
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Task',align: 'left',value: 'taskName', width:'15%', sortable:true},
                {text: 'Hours',align: 'left',value: 'hoursStr', width:'5%',sortable:true},
                {text: 'Chargeable Hours',align: 'left',value: 'chargeableHours', width:'5%',sortable:true},
                {text: 'Duration',align: 'left',value: 'startTime', width:'10%',sortable:true},
                {text: 'Purpose',align: 'left',value: 'offsetOrPay', width:'10%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
            ],
        cutoff_details: null,
        overtime_details: [],
        dialogOvertime: false,
        timeReport: null
      }
    },
    methods: {  
        showOvertime() {
            var data = {
                mode: 'Add',
                cutoff: this.cutoff_details
            }
            this.$refs.overtimeRef.setParams(data)
            this.dialogOvertime = true
        },
        async downloadToExcel() {
        },
        viewDetails(data) {
            this.$router.push(`details/${data.overtimeId}`)
        }, 
        async getOvertime(show_loading) {
            try {
                this.loading = show_loading
                const response = await overtimeApi.getByCutoffByUser(this.selectedCutOffId)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.overtime_details = response.data.items
                    this.timeReport = response.data.timeReport
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        this.commonfn = commonfn

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'My Overtime',
            headerPageTitle: ''
        })

        this.getOvertime(true)
    },
    computed: {
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details!=null)
                return `${this.$moment(this.cutoff_details.cutoffStart).format('MMM DD, YYYY')} to ${this.$moment(this.cutoff_details.cutoffEnd).format('MMM DD, YYYY')}`
        },
        approved_timereport() {
            if (this.timeReport!=null)
                return this.timeReport.status==commonfn.getStatusCode('Approved')
        },
        frozen_period() {
            if (this.cutoff_details!= null) 
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closed_period() {
            if (this.cutoff_details!= null) 
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        },
        disableConditions() {
            return (this.loading||
                    this.frozen_period || 
                    this.closed_period ||
                    this.approved_timereport
                    )  
        },
    }
}
</script>